import React from "react";
import { fetchData } from "../utility/fetcher";

// cache will contain { domainName: 'domain.com', data: {} }
let rdapCache = {};

const initState = {
	loading: false,
	data: null,
	error: null,
};

const reducer = (state, action) => {
	switch (action.type) {
		case "FETCHING":
			return { ...state, loading: true, data: null };
		case "FETCHED":
			return { ...state, loading: false, data: action.payload };
		case "FETCH_ERROR":
			return { ...initState, error: action.payload };
		default:
			return state;
	}
};

const useRdapFetch = (inputIsValid, rdapInput) => {
	const [state, dispatch] = React.useReducer(reducer, initState);
	const URL = "/api/rdap-lookup";

	React.useEffect(() => {
		if (!inputIsValid) return;

		if (rdapCache.domainName === rdapInput)
			return dispatch({ type: "FETCHED", payload: rdapCache.data });

		const fetchRdapData = async () => {
			let searchQuery = rdapInput.trim();

			if (
				searchQuery.indexOf("http://") >= 0 ||
				searchQuery.indexOf("https://") >= 0
			) {
				searchQuery = searchQuery
					.replace("https://", "")
					.replace("http://", "");
			}

			searchQuery = searchQuery.replace(/\/+$/, "");

			const body = { domain: searchQuery };
			try {
				const result = await fetchData(URL, body);
				if (result.status === "OK") {
					dispatch({ type: "FETCHED", payload: result.data });
					rdapCache = { domainName: rdapInput, data: result.data };
				}
				if (result.status === "error") {
					dispatch({ type: "FETCH_ERROR", payload: result.message });
				}
			} catch (err) {
				console.log(err);
				dispatch({ type: "FETCH_ERROR", payload: err });
			}
		};

		dispatch({ type: "FETCHING" });
		const timer = setTimeout(() => {
			fetchRdapData();
		}, 800);

		return () => {
			clearTimeout(timer);
		};
	}, [rdapInput, inputIsValid]);

	return { rdapData: state };
};

export default useRdapFetch;
